import {handleKeepRoute} from '@/router/routes'
import {getNameCode, getRoles} from '@/utils/cookie'
import {tenantUser} from '@/utils/role'

/**
 * 根据用户信息处理路由
 */
export const handleRouteByUserRole = (routes, userRole) => {
  let userRoutes = []
  routes.forEach((route) => {
    // 判断是否保留路由
    if (handleKeepRoute(route, userRole)) {
      if (route.children && route.children.length > 0) {
        route.children = handleRouteByUserRole(route.children, userRole)
      }
      userRoutes.push(route)
    }
  })
  return userRoutes
}

/**
 * 将store中取出的路由格式化
 * @param menus
 * @returns {[]}
 */
export const formatRoutes = (menus) => {
  let routers = []
  menus.forEach((menu) => {
    if (!menu) {
      return false
    }
    let {name, path, component, children, meta} = menu
    if (children && children instanceof Array) {
      children = formatRoutes(children)
    }
    meta = JSON.parse(JSON.stringify(meta || {}))
    let fmRouter = {
      name: name,
      path: path,
      component(resolve) {
        require([`@/views${(component || path)}.vue`], resolve)
      },
      children: children,
      meta: meta
    }
    routers.push(fmRouter)
  })
  return routers
}

export const getLoginPath = () => {
  return `/${getNameCode()}/login`
}

export const getLoginPathByRole = () => {
  const roles = getRoles()
  if (roles === tenantUser) {
    return getLoginPath()
  } else {
    return '/login/platform'
  }
  // let path = '/'
  // if (roles === tenantUser) {
  //   path = getLoginPath()
  // } else if (roles === platformUser) {
  //   path = '/login/platform'
  // }
  // return path
}



// WEBPACK FOOTER //
// ./src/utils/router/other.js